module.exports = __webpack_public_path__ + "img/facebook.eb0d11be.png";